import { newNote } from './data/notes'
import { nanoid } from 'nanoid'
import type { Note } from './types/index'
const svgsrc = import('./components/edit-icon.svg')

tag notes-list
	css .notes-list-container
		bgc: white
		bdr: 1px solid gray2
		min-height@md: 100vh

		button
			bgc:cooler2 bgc@hover:cool3
			bd:none
			cursor:pointer
			d:flex
			ai:center
			jc:center
			p:4
			w:100%
			tween:background-color .3s ease-in
		
		svg
			ml:2
			size:4


	<self>
		<div .notes-list-container>
			<button @click=emit('addNewNote')> "Add a note" 
				<svg src=svgsrc />
			for note in state.notes
				<notes-list-item note=note>
